import { createContext } from "react";
import { useState, useEffect } from "react";

import { USER_LOCAL_STORAGE_KEY } from "@constants/Auth.constants.js";
import { fetchProfile } from "@libs/apiRequest.js";
import { decodeData } from "@libs/secureLocalStorage.js";

export const AuthContext = createContext();

export const AuthContextProvider = ({ children }) => {
  const [currentUser, setCurrentUser] = useState(
    JSON.parse(localStorage.getItem(USER_LOCAL_STORAGE_KEY)) || null
  );
  const [currentUserRole, setCurrentUserRole] = useState(null);

  // Update currentUser and persist to localStorage
  const updateUser = (data) => {
    setCurrentUser(data);
  };

  useEffect(() => {
    localStorage.setItem(USER_LOCAL_STORAGE_KEY, JSON.stringify(currentUser));
  }, [currentUser]);

  // Fetch and set role whenever currentUser changes
  useEffect(() => {
    const fetchUserAccess = async () => {
      if (!currentUser) {
        setCurrentUserRole(null);
        return;
      }

      try {
        const profileResponse = await fetchProfile();
        const parsedProfileData = JSON.parse(
          decodeData(profileResponse.encodedProfile)
        );
        setCurrentUserRole(parsedProfileData.role);
      } catch (err) {
        console.error("Failed to fetch user role:", err);
        setCurrentUserRole(null);
      }
    };

    fetchUserAccess();
  }, [currentUser]);

  return (
    <AuthContext.Provider value={{ currentUser, currentUserRole, updateUser }}>
      {children}
    </AuthContext.Provider>
  );
};
